// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3gSGk","ranges":"BmiRanges_ranges__3RdIO"};